import {Component, inject} from '@angular/core';
import {
  ColumnPropertyGroup,
  FiltersValues,
  RecordData,
  RecordsDataRequestQueryParams,
  RecordTableColumnParams,
  RecordTableParams
} from '../../../core/types/records-table.types';
import {Pageable} from '../../../core/types/pagable.types';
import {RecordTableApiService} from '../../../core/services-api/record-table-api.service';
import {UtilityService} from '../../../core/services/utility.service';
import {BasePageComponent} from './base-page.component';
import {defaultRecordsDataRequestQueryParams} from '../../../core/models/default-records-data-request-query-params';
import {ErrorService} from "../../../core/services/error.service";

@Component({
  standalone: true,
  template: '',
})
export class TablePageComponent extends BasePageComponent {
  protected utilityService: UtilityService = inject(UtilityService);
  protected errorService: ErrorService = inject(ErrorService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  protected queryParams: RecordsDataRequestQueryParams = defaultRecordsDataRequestQueryParams;

  protected getRecordTableColumnsParams(path: string): Promise<RecordTableParams> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.getRecordTableParams(path).subscribe({
        next: (tableParams: RecordTableParams) => resolve(tableParams),
        error: (error) => reject(error)
      });
    });
  }

  protected getRecordTableData(path: string, queryParams: RecordsDataRequestQueryParams): Promise<Pageable<RecordData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchRecordTableData(path, queryParams).subscribe({
        next: (recordsTableData: Pageable<RecordData>) => resolve(recordsTableData),
        error: (error) => reject(error)
      });
    });
  }

  protected getGroupsFromRecordTableColumnsParams(recordTableColumnParams: Array<RecordTableColumnParams>): Array<ColumnPropertyGroup> {
    return recordTableColumnParams
      .map((columnParams: RecordTableColumnParams) => columnParams.columnProperties.GROUP)
      .filter(Boolean) // remove undefined
      .filter((group, index, arr) => arr.findIndex(group2 => (group?.id === group2?.id)) === index) as Array<ColumnPropertyGroup>// remove duplicates
  }

  protected getColumnsForGroup(group: ColumnPropertyGroup, recordTableColumnParams: Array<RecordTableColumnParams>): Array<RecordTableColumnParams> {
    return recordTableColumnParams.filter((column: RecordTableColumnParams) => column.columnProperties.GROUP?.id === group.id);
  }

  protected getQueryParamsAccordingToFilters(recordsTableFiltersValues: FiltersValues): RecordsDataRequestQueryParams {
    const queryParams = this.utilityService.removeEmptyProperties({
      ...this.queryParams,
      ...recordsTableFiltersValues,
      page: 0
    });

    const preparedQueryParams = this.utilityService.removeEmptyProperties(queryParams);
    this.queryParams = preparedQueryParams;

    return preparedQueryParams;
  }
}
